import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";
import React from "react";
import { RiLinkM } from "react-icons/ri";

import { FaTimes } from "react-icons/fa";
import { GrMailOption } from "react-icons/gr";
import { setModalStatus } from "../../redux/auth/auth.actions";
import { useDispatch } from "react-redux";

function InviteOptionModal({ open, onClose }) {
  const dispatch = useDispatch();

  const invite = (item) => {
    onClose();
    dispatch(setModalStatus(item));
  };
  return (
    <Modal className="w-full  " isOpen={open} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        className=" max-w-[421px] pt-[22px]"
        borderRadius={20}
        containerProps={{
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="flex  px-[20px] relative items-center w-full">
          <div
            onClick={onClose}
            className="w-[36px] absolute cursor-pointer  h-[36px] float-left bg-[#ffffff] border-[.1px] rounded-full my-[rem]  justify-center flex items-center"
          >
            <FaTimes size={12} className="float-left text-[#050558]" />
          </div>

          <h4 className="text-center mx-auto text-base text-black font-[500] text-[20px]">
            Invite
          </h4>
        </div>
        <ModalBody>
          <div className="mt-[1rem] gap-[14px] mb-[1rem] align-middle  ">
            <div
              onClick={() => invite(77)}
              className="flex p-1 hover:bg-[#e2e4e998] rounded-[9px] cursor-pointer mb-[23px] gap-[14px]"
            >
              <div className="w-[44px] flex justify-center items-center h-[44px] rounded-[8px] p-[10px] bg-[#e2e4e9]">
                <RiLinkM className="w-[15.89px] h-[15.89px] text-[#0a0d14] text-base  font-[800]" />
              </div>
              <div className="w-[268px]">
                <h4 className="font-[500] text-[16px] text-base text-black">
                  Invite via Link
                </h4>
                <p className="font-[500] text-[14px] text-[#525866]">
                  Generate a shareable link to invite family and friends.
                </p>
              </div>
            </div>
            <div
              className="flex p-1 hover:bg-[#e2e4e998] rounded-[9px] cursor-pointer  gap-[14px]"
              onClick={() => invite(73)}
            >
              <div className="w-[44px] flex justify-center items-center h-[44px] rounded-[8px] p-[10px] bg-[#e2e4e9]">
                <GrMailOption className="w-[18px] h-[15px] text-[#0a0d14]" />
              </div>
              <div className="w-[268px]">
                <h4 className="font-[500] text-[16px] text-black">
                  Invite via Email
                </h4>
                <p className="font-[500] text-[14px] text-[#525866]">
                  Using email addresses invite family and friends.
                </p>
              </div>
            </div>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default InviteOptionModal;
